<template>
  <div class="main">
    <topImg :img="require('@/assets/images/project/banner.png')"></topImg>
    <div class="content">
      <el-tabs v-model="tabSelected" @tab-click="tabChange" class="tab">
        <el-tab-pane label="软件"></el-tab-pane>
        <el-tab-pane label="硬件"></el-tab-pane>
      </el-tabs>
      <div class="tabContent">
        <div class="tabItem" v-for="item in list" :key="item.id">
          <div>
            <div class="headerLine" v-if="item.headline">{{ item.headline }}</div>
            <div class="detail">
              <img :src="item.img" alt="" />
              <div class="detailContent">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabSelected: '0',
      softwareList: [
        {
          headline: '教学平台 ',
          title: '智慧教学平台',
          desc: '智慧教学平台构建了智能化的在线教学系统。不仅支持多人在线学习，提供丰富的课程资源，还配备实时互动学习工具和真实的在线实训环境。将在线教学与在线实践紧密结合，使师生能够便捷的开展数字化教学与练习，实现"边学边练、反复加强"的学习效果。同时，平台还构建了项目和比赛机制，通过学生的参与和产生的作品，有利于对学生评价并促进学生自主学习。',
          img: require('@/assets/images/project/pic_1.png'),
        },
        {
          headline: '教学平台 ',
          title: '校级虚拟仿真教学平台',
          desc: '校级虚拟仿真教学平台是一款基于XR虚拟现实技术的智慧教学系统。平台以三大核心功能赋能现代教育：支持教师快速开发3D交互式微课，覆盖多类学科全场景；支持VR多人协同操作与远程互动教学；通过实时数据分析，实现学情精准监测与教学动态优化。目前已在多所高校成功应用，通过"虚实结合"的创新教学模式提升教学安全性与互动性，成为推动教育数字化转型的标杆平台。   ',
          img: require('@/assets/images/project/pic_2.png'),
        },
        {
          headline: '实训平台 ',
          title: '远程实训平台 ',
          desc: '远程实训平台是一款基于虚拟现实技术的在线教学实训平台，旨在为师生提供更加真实、高效、便捷的远程实训教学。平台采用先进的虚拟现实及人工智能技术，能够为师生提供个性化的学习方案和实训模拟环境，帮助学生快速掌握实用技能。同时，平台还提供多种在线语音交流和多人互动协同方式，让学生可以随时随地与老师交流学习心得，共同进步。远程实训平台是未来教育的重要趋势，将为广大师生带来更加优质的学习体验和更加广阔的发展空间。',
          img: require('@/assets/images/project/pic_3.png'),
        },
        {
          headline: '工具软件 ',
          title: '灵创编辑器 ',
          desc: ' 灵创是一套支持VR、AR的3D互动教学产品，包括3D编辑器和播放器两个部分。灵创具备海量的3D模型教学资源，支持中职、高职和本科学段。在灵创平台，老师可以将3D模型变成一节知识点丰富的教学课件。不仅如此，灵创课件还支持多种教学终端，根据不同的终端特点，体现出个性化的教学特色。',
          img: require('@/assets/images/project/pic_4.png'),
        },
        {
          headline: '工具软件 ',
          title: '大空间XR资源案例库软件',
          desc: '大空间XR互动资源库是基于沉浸Cave空间及大屏幕动作捕捉互动系统开发的多种类型的互动资源库，资源库涵盖包括古建筑学习、工业制造、医疗、汽车、水利电力、环境地理、设备拆装教学等多种类型资源。',
          img: require('@/assets/images/project/pic_5.png'),
        },
        {
          headline: '工具软件 ',
          title: '虚拟现实桥接软件',
          desc: '支持任意类型的沉浸式交互显示环境，如CAVE洞穴式交互显示系统，Power Wall(CADWall)大型平面立体交互显示系统，多通道环幕立体显示系统，立体显示器，立体电视，HMD, Workbench、Reality Center等硬件系统。',
          img: require('@/assets/images/project/pic_6.png'),
        },
      ],
      hardwareList: [
        {
          title: '裸眼3D一体机',
          desc: '这是一款具有革命性的无需眼镜的 3D 全息一体式设备。它集多种功能于一体，能让用户无需佩戴笨重的眼镜就能体验到沉浸式的 3D 全息视觉效果。',
          img: require('@/assets/images/project/pic-1.png'),
        },
        {
          title: 'LED 互动屏幕',
          desc: `这款 LED 立体显示系统采用了前沿的 LED 显示技术，并融合了多种技术。在虚拟仿真领域中属于主流产品。
凭借先进的硬件和优化的 LIBSEEN 软件，它能有效地展示信息。它能够收集众多信号源，支持大规模多屏拼接，具有强大的处理能力，并能提供清晰流畅的视觉效果。操作简便，能够实现灵活的屏幕显示，不受物理限制的约束。`,
          img: require('@/assets/images/project/pic-2.png'),
        },
        {
          title: 'CAVE 系统',
          desc: 'CAVE（洞穴式自动虚拟环境）是一种大规模的虚拟仿真系统。它通过视觉、触觉、声音等方式营造出一个沉浸式的环境。结合内容——虚拟仿真实验资源，它能够实现诸如虚拟场景漫游体验、高风险实验的沉浸式模拟以及不可重现场景的重现等功能，例如产品演示和体验。它被应用于应急安全演练、军事模拟训练以及医学研究和教育等领域。',
          img: require('@/assets/images/project/pic-3.png'),
        },
        {
          title: '虚拟现实头戴设备',
          desc: '这是一款高性能的虚拟现实一体机设备。它为用户提供了沉浸式的虚拟现实体验，并配备了丰富的 Libseen 课程资源。',
          img: require('@/assets/images/project/pic-4.png'),
        }
      ],
    };
  },
  computed: {
    list() {
      return this.tabSelected === '0' ? this.softwareList : this.hardwareList;
    },
  },
  mounted() {},
  methods: {
    tabChange() {},
  },
  //   watch: {
  //     tabSwlected(tab) {
  //       console.log('change', tab)
  //       if (tab === 0) {
  //         this.getHighList()
  //       } else {
  //         this.get中小学List()
  //       }
  //     }
  //   }
};
</script>
<style lang="less" scoped>
.main {
  background: #fff;
  .tabContent {
    .tabItem {
      padding: 60px 0 100px 0;
      > div {
        width: 1200px;
        margin: 0 auto;
        .headerLine {
          font-weight: 600;
          font-size: 28px;
          color: #444a62;
          line-height: 40px;
          text-align: center;
          width: 100%;
          position: relative;
          &:after {
            content: "";
            width: 27px;
            height: 5px;
            background: #f5a18b;
            display: block;
            position: absolute;
            left: 50%;
            margin-left: -13px;
            bottom: -13px;
            border-radius: 3px;
          }
        }
        .detail {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 60px;
          img {
            width: 478px;
            height: 316px;
            margin-right: 36px;
          }
          .detailContent {
            width: 700px;
            .title {
              font-weight: 600;
              font-size: 32px;
              color: #000000;
              line-height: 45px;
            }
            .desc {
              margin-top: 20px;
              font-weight: 400;
              font-size: 16px;
              color: #000000;
              line-height: 38px;
            }
          }
        }
      }
    }
    .tabItem:nth-child(2n) {
      background: url("~@/assets/images/project/bj.png");
      background-size: 100% 100%;
      > div {
        .detail {
          flex-direction: row-reverse;
          img {
            margin-right: 0;
            margin-left: 36px;
          }
        }
      }
    }
    .tabItem:nth-child(2) {
      background: url("~@/assets/images/project/bj2.png");
    }
  }
  .content {
    width: 100%;
    margin: 0 auto;
    .tab {
      width: 1200px;
      margin: 0 auto;
      margin-top: 60px;
    }
    // 修改tab分页标签组件样式
    /deep/.el-tabs__item {
      width: 150px;
      padding: 0;
      color: #6b738c;
      text-align: center;
      border-radius: 20px;
    }
    /deep/.el-tabs__nav {
      border-radius: 20px;
      background-color: #efefef;
    }
    /deep/.el-tabs__item:hover {
      color: #6b738c;
    }
    /deep/.el-tabs__item.is-active,
    /deep/.el-tabs__item.is-active:hover {
      color: #fff;
      background: #f27529 !important;
    }
    /deep/.el-tabs__active-bar,
    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    // 修改页面分页组件样式
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      color: #fff;
      border: 0;
      background: #f27529 !important;
    }
  }
}
@media (max-width: 1000px) {
  .main {
    .content {
      .tab {
        width: 100%;
        margin-top: 40px;
        padding: 0 48px;
        box-sizing: border-box;
      }
      /deep/.el-tabs__item {
        width: 120px;
        font-size: 28px;
        padding: 10px 0;
        height: auto;
        line-height: 1.5;
      }
    }
    .tabContent {
      .tabItem {
        padding: 60px 48px;
        box-sizing: border-box;
        > div {
          width: 100%;
          .headerLine {
            font-size: 32px;
          }
          .detail {
            flex-direction: column;
            margin-top: 40px;
            img {
              width: 100%;
              height: auto;
              margin-right: 0;
              margin-bottom: 30px;
            }
            .detailContent {
              width: 100%;
              .title {
                font-size: 36px;
                line-height: 50px;
              }
              .desc {
                font-size: 26px;
                line-height: 44px;
                margin-top: 16px;
              }
            }
          }
        }
      }
      .tabItem:nth-child(2n) {
        > div {
          .detail {
            flex-direction: column;
            img {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>
